import {isEditMode, useFormMode} from "@contexts/FormModeContext";

const QuickStepList = ({
   stepList,
   currentStep,
   backToForm,
   onSubmit,
   saveButtonText = 'Update Submission',
   saveButtonIconClass = 'fa fa-save'
}) => {
   
   const {mode} = useFormMode();
   
   if(!Array.isArray(stepList) || stepList.length < 2) {
      return null;
   }
   
   const onStepClick = (step) => {
      
      if(!backToForm || typeof backToForm !== 'function') {
         return;
      }
      
      
      backToForm && backToForm({step});
      
      window.scrollTo({
         top: 0,              // 0 represents the very top of the document
         behavior: 'smooth',  // Ensures a gentle, animated scroll
      });
   }
   
   return (
      <div className="quick-step-list">
         
         <div className="dropup">
            
            <button
               className="btn btn-primary2 btn-outline-primary dropdown-toggle"
               type="button"
               data-bs-toggle="dropdown"
               aria-expanded="false"
            >
               Jump to step
            </button>
            
            <ul className="dropdown-menu">
               
               {stepList?.map((item, index) => (
                  <li key={index} style={{
                     listStyle: 'none',
                  }}>
                     
                     <a
                        className={`dropdown-item ${currentStep === item.step ? 'active' : ''}`}
                        href="#"
                        onClick={(e) => {
                           e.preventDefault();
                           onStepClick(item.step)
                        }}
                     >
                        {item.label} <i className="fa fa-arrow-right"></i>
                     </a>
                  </li>
               ))}
            </ul>
         </div>
         
         {/*{isEditMode(mode) && onSubmit && (
            <button type="submit" className="btn btn-success" onClick={onSubmit}>
               {saveButtonIconClass && (
                  <i className="fa fa-save"></i>
               )} {saveButtonText}
            </button>
         )}*/}
      
      </div>
   )
};

export default QuickStepList;